// @flow

import React from 'react';
import type { Node } from 'react';
import { LinkStyled as Link } from '../../../link';
import type { CombinedListStylesTypes, Limits } from '../../types';
import type { ColorScheme } from '../../../../types/theme';
import ListItemComponent, {
  ListItemContainer,
  ListItemIcon,
  ListItemContent,
} from './styled';
import {
  Cross,
  Check,
  Numbered,
  Bullet,
  Minus,
  Plus,
} from '../listStyles';

export type Props = {
  children: Node,
  url: ?string,
  type?: CombinedListStylesTypes,
  index: number,
  scheme: ColorScheme,
  limit: ?Limits,
  collapsed: boolean,
  minimalistic: boolean,
};

type TypeMap = {
  [CombinedListStylesTypes]: any,
};

const typeMap: TypeMap = {
  cross: Cross,
  check: Check,
  numbered: Numbered,
  bullets: Bullet,
  plus: Plus,
  minus: Minus,
};

const ListItem = ({
  children,
  url,
  type = 'undefined',
  index,
  scheme,
  limit,
  collapsed,
  minimalistic,
}: Props) => {
  if (!typeMap[type]) {
    throw Error(`List style ${type} isn't available use one of: ${Object.keys(typeMap).join(', ')}`);
  }

  const Icon = typeMap[type];
  let listContent;
  if (url) {
    // TODO: this should be Button variant=link https://justlease.atlassian.net/browse/LISTO-309
    listContent = <Link href={url}>{children}</Link>;
  } else {
    listContent = children;
  }

  return (
    <ListItemComponent
      type={type}
      minimalistic={minimalistic}
      limit={limit || 0}
      collapsed={collapsed}
    >
      <ListItemContainer>
        <ListItemIcon>
          <Icon
            index={index + 1}
            scheme={scheme}
          />
        </ListItemIcon>
        <ListItemContent>
          {listContent}
        </ListItemContent>
      </ListItemContainer>
    </ListItemComponent>
  );
};

ListItem.defaultProps = {
  type: 'undefinded',
};

export default ListItem;
